<template>
  <Dialog :commonDialog="demeritDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <span v-if="doUpdate">Update</span>
      <span v-else>Add</span>
      <span>&nbsp;Demerit Point</span>
    </template>
    <template v-slot:body>
      <v-form ref="demeritForm" v-model.trim="formValid" lazy-validation>
        <v-row v-if="demeritDialog" class="mx-3">
          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-added_at"
              >Date</label
            >
            <DatePicker
              solo
              flat
              :mandatory="false"
              :nullable="true"
              placeholder="Date"
              v-model="createData.added_at"
            ></DatePicker>
          </v-col>

          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-violation_type"
              >Violation Type</label
            >
            <v-text-field
              id="y-last_name"
              v-model.trim="createData.violation_type"
              dense
              filled
              label="Violation Type"
              solo
              flat
              color="cyan"
            ></v-text-field>
          </v-col>

          <v-col md="4">
            <label
              class="font-size-16 font-weight-500 required"
              for="y-demerit_points"
              >Demerit Points</label
            >
            <v-text-field
              dense
              filled
              color="cyan"
              label="Demerit Points"
              :rules="[
                validateRules.required(
                  createData.demerit_points,
                  'Demerit Points'
                ),
              ]"
              solo
              flat
              class="width-100"
              type="number"
              min="0"
              max="9999"
              hide-spin-buttons
              v-model.trim.number.lazy="createData.demerit_points"
              v-on:keypress="limitDecimal($event, createData.demerit_points)"
            ></v-text-field>
          </v-col>

          <v-col md="4">
            <label
              class="font-size-16 font-weight-500 required"
              for="y-issued_by"
              >Issued by</label
            >
            <v-text-field
              id="y-issued_by"
              v-model.trim="createData.issued_by"
              :rules="[
                validateRules.required(createData.issued_by, 'Issued by'),
              ]"
              dense
              filled
              label="Issued by"
              solo
              flat
              color="cyan"
            ></v-text-field>
          </v-col>

          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-description"
              >Description</label
            >
            <v-textarea
              id="y-last_name"
              v-model.trim="createData.description"
              :rules="[
                validateRules.maxLength(
                  createData.description,
                  'Description',
                  100
                ),
              ]"
              label="Description"
              filled
              dense
              solo
              flat
              color="cyan"
              rows="2"
              v-on:keypress="(e) => manageLimitdescr(e)"
              v-on:paste="(e) => onPaste(e)"
            ></v-textarea>
            <div class="text-right">
              {{
                createData.description ? createData.description.length : 0
              }}/100
            </div>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:action>
      <v-btn
        v-on:click="$emit('close', true)"
        class="mx-2 custom-grey-border custom-bold-button"
      >
        Cancel
      </v-btn>
      <v-btn
        class="mx-2 custom-bold-button white--text"
        @click="saveDemeritPoints()"
        color="cyan"
        :loading="pageLoading"
        :disabled="!formValid || pageLoading"
      >
        <span v-if="doUpdate">Update</span>

        <span v-else>Add</span>
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import ApiService from "@/core/services/api.service";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import Dialog from "@/view/pages/partials/Dialog";
import DatePicker from "@/view/components/DatePicker";
import { InitializeError, ErrorEventBus } from "@/core/lib/message.lib";

//import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
export default {
  model: {
    prop: "value",
    event: "input",
  },
  mixins: [ValidationMixin, CommonMixin],
  data() {
    return {
      pageLoading: false,
      demeritPoints: [],
      createData: {
        id: null,
        violation_type: null,
        description: null,
        demerit_points: null,
        issued_by: null,
        added_at: null,
        driver: null,
      },
    };
  },
  props: {
    demeritDialog: {
      type: Boolean,
      default: false,
    },
    doSave: {
      type: Boolean,
      default: false,
    },
    doUpdate: {
      type: Boolean,
      default: false,
    },

    driverId: {
      type: Number,
      default: 0,
    },

    editItem: {
      type: Object,
      default: null,
    },
  },
  watch: {
    editItem: {
      handler(editItem) {
        if (editItem && Object.keys(editItem).length > 0) {
          this.createData = {
            id: editItem.id || null,
            violation_type: editItem.violation_type || null,
            description: editItem.description || null,
            demerit_points:
              Number(editItem.demerit_points) % 1 === 0
                ? parseInt(editItem.demerit_points)
                : parseFloat(editItem.demerit_points) || null,
            issued_by: editItem.issued_by || null,
            added_at: editItem.added_at || null,
            driver: editItem.driver || this.driverId,
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.createData.description;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.createData.description = trimValue;
        e.preventDefault();
      }
    },

    manageLimitdescr(e) {
      if (
        this.createData.description &&
        this.createData.description.length > 99
      ) {
        e.preventDefault();
      }
    },

    saveDemeritPoints() {
      this.$refs["demeritForm"].validate();
      const formErrors = this.validateForm(this.$refs["demeritForm"]);
      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      this.pageLoading = true;

      ApiService.post(
        `engineer/${this.driverId}/demerit-points`,
        this.createData
      )
        .then(() => {
          this.pageLoading = false;
          this.$emit("success", true);
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
  },
  components: {
    Dialog,
    DatePicker,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 60);
    },
  },
  mounted() {},
};
</script>
